import Ext from 'Ext'
import BaseDatePicker from './at_base_date_picker'
Ext.namespace('AT');

const DatePicker = Ext.extend(BaseDatePicker,
{
    showOkCancelButtons: true,
    showClearButton: false,
    /**
     * Determines whether to fire 'update' events.
     */
    useUpdateEvent : false,

    initComponent : function(){

        DatePicker.superclass.initComponent.call(this);

        this.addEvents(
            /*
             * @event update
             * Fires when the contents of the date picker are updated, e.g. when the cursor is moved or month is changed,
             * but the selection is not submitted (the date picker remains visible).
             * Fires only if {@link AT.DatePicker#useUpdateEvent} is true.
             * @param {DatePicker} this
             * @param {Date} date The currently selected date
             */
            'update',
            /*
             * Fires when the user cancels the date selection.
             * @param {DatePicker} this
             */
            'cancel'
        );

        this.clearMonthYearSwitchingState();

        this.suppressActiveDayFocus = false;
    },

    // override
    update : function(date, forceRefresh, wasMonthOrYearSwitched)
    {
        if (wasMonthOrYearSwitched)
        {
            this.setMonthYearSwitchingStateIfNotSet();
            
            if (this.getMonthYearSwitchingState() == 'keep_month_end')
            {
                date = date.getLastDateOfMonth();
            }
        }
        else if (date != this.activeDate)
        {
            this.clearMonthYearSwitchingState();
        }


        var vd = this.activeDate;

        var self = this;

        var fireUpdateEvent = function ()
        {
            if (self.useUpdateEvent)
                self.fireEvent("update", self, self.activeDate);            
        };

        if (date < this.actualMin)
        {
            if (this.activeDate.getMonth() != this.actualMin.getMonth())
            {
                this.activeDate = this.actualMin;
            }
        }
        else if (date > this.actualMax)
        {
            if (this.activeDate.getMonth() != this.actualMax.getMonth())
            {
                this.activeDate = this.actualMax;
            }
        }
        else
        {
            this.activeDate = date;
        }

        if (!forceRefresh && vd && this.el)
        {
            var t = this.activeDate.getTime();
            if (vd.getMonth() == this.activeDate.getMonth() && vd.getFullYear() == this.activeDate.getFullYear())
            {
                this.cells.removeClass("x-date-selected");
                this.cells.each(function(c)
                {
                    if (c.dom.firstChild.dateValue == t)
                    {
                        c.addClass("x-date-selected");
                        
                        if (! self.suppressActiveDayFocus)
                        {
                            setTimeout(function()
                            {
                                try
                                {
                                    c.dom.firstChild.focus();
                                }
                                catch(e)
                                {
                                }
                            }, 50);
                            return false;
                        }
                    }
                    return undefined;
                });
                fireUpdateEvent();
                this.suppressActiveDayFocus = false;
                return;
            }
        }

        if (this.todayBtn)
            this.todayBtn.setDisabled(this.todayIsDisabled);

        this.updateCells( this.activeDate );

        this.suppressActiveDayFocus = false;
        fireUpdateEvent();
    },

    setCellClasses: function(cell, isWeekend, date, today)
    {
        DatePicker.superclass.setCellClasses.call(this, cell, isWeekend, date, today);
        if (date.isSameDate( this.activeDate ))
        {
            cell.className += " x-date-selected";

            if (!this.suppressActiveDayFocus)
            {
                setTimeout( function ()
                            {
                                try
                                {
                                    cell.firstChild.focus();
                                }
                                catch( e )
                                {
                                }
                            }, 50 );
            }
        }
    },

    // override
    onRender : function (container, position)
    {
        DatePicker.superclass.onRender.call(this, container, position);

        // Due to the fact that 'showToday' is actually 'show bottom pane',
        // if showToday is false, the OK and Cancel buttons also won't be shown,
        // since there's no element to render them to.
        if (this.showToday)
        {
            var bottomArea = this.el.child("td.x-date-bottom", true);

            bottomArea.innerHTML = [
                '<table width="100%" cellpadding="0" cellspacing="0"><tbody><tr>',
                this.showClearButton ? '<td class="x-date-at-clear-cell"></td>' : '',
                this.showOkCancelButtons ? '<td class="x-date-at-ok-cancel-cell x-date-mp-btns"></td>' : '',
                '<td class="x-date-at-today-cell"></td>',
                '</tr></tbody></table>'
            ].join('');

            // HTML copied (and slightly changed) from month picker
            var buttonTemplate = new Ext.Template('<em unselectable="on"><button type="button" type="{1}">{0}</button></em>');

            if (this.showClearButton)
            {
                this.clearButton = new Ext.Button({
                    renderTo: this.el.child("td.x-date-at-clear-cell", true),
                    text: this.clearText,
                    template: buttonTemplate,
                    handler: this.clear,
                    scope: this
                });
            }

            if( this.showOkCancelButtons )
            {
                //noinspection JSUnusedGlobalSymbols
                this.atOkBtn = new Ext.Button({
                    renderTo: this.el.child("td.x-date-at-ok-cancel-cell", true),
                    text: this.okText,
                    template: buttonTemplate,
                    handler: this.onOkClick,
                    scope: this
                });

                //noinspection JSUnusedGlobalSymbols
                this.atCancelBtn = new Ext.Button({
                    renderTo: this.el.child("td.x-date-at-ok-cancel-cell", true),
                    text: this.cancelText,
                    template: buttonTemplate,
                    handler: this.onCancelClick,
                    scope: this
                });
            }
            // Actually, the today button is created twice (the first time in the base class),
            // so this might be a subject for optimization.
            var today = (window.currentUserTime()).dateFormat(this.format);
            this.todayBtn = new Ext.Button({
                renderTo: this.el.child("td.x-date-at-today-cell", true),
                text: String.format(this.todayText, today),
                template: buttonTemplate,
                handler: this.selectToday,
                scope: this
            });

            // replace the default confusing spacebar handler
            this.todayKeyListener.disable();
            //noinspection JSUnusedGlobalSymbols
            this.spacebarListener = new Ext.KeyMap(this.eventEl, {
                key: Ext.EventObject.SPACE,
                handler: this.onOkClick,
                scope: this,
                stopEvent: true
            });
        }

        Ext.get(this.el).addClass("atap-date-picker");
    },

    /**
     * Behaves as if the user clicked on an active day ('active' means the day under cursor).
     * Selects the active day and fires the 'select' event.
     */
    selectActiveDate : function ()
    {
        this.suppressActiveDayFocus = true; // Hack: Suppress automatic active day focusing in the next update().
                                            // Because focusing is deferred, and the date picker is usually hidden
                                            // after calling this method, focusing would cause a lot of trouble.
        this.setValue(this.activeDate);
        this.fireEvent("select", this, this.value);
    },

    /**
     * Cancels the selection.
     */
    cancel : function ()
    {
        this.fireEvent("cancel", this);
    },

    onOkClick : function ()
    {
        this.selectActiveDate();    
    },

    onCancelClick : function ()
    {
        this.cancel();
    },


    // override
    showPrevMonth : function()
    {
        this.update(this.activeDate.add("mo", -1), false, true);
    },

    // override
    showNextMonth : function()
    {
        this.update(this.activeDate.add("mo", 1), false, true);
    },

    // override
    showPrevYear : function()
    {
        var newDate = this.activeDate.add("y", -1);
        this.update(this.fix29februaryIssue(newDate), false, true);
    },

    // override
    showNextYear : function()
    {
        var newDate = this.activeDate.add("y", 1);
        this.update(this.fix29februaryIssue(newDate), false, true);
    },

    monthPickerApply : function (year, month)
    {
        var d = new Date(year, month, (this.activeDate || this.value).getDate());
        if (d.getMonth() != month){
            // "fix" the JS rolling date conversion if needed
            d = new Date(year, month, 1).getLastDateOfMonth();
        }
        this.update(d, false, true);
        this.hideMonthPicker();
    },

    setMonthYearSwitchingStateIfNotSet : function ()
    {
        if (this.monthYearSwitchingState == 'off')
        {
            if (this.activeDate.format("j") == this.activeDate.getDaysInMonth())
                this.monthYearSwitchingState = 'keep_month_end';
            else
                this.monthYearSwitchingState = 'keep_same_day';
        }
    },

    clearMonthYearSwitchingState : function ()
    {
        this.monthYearSwitchingState = 'off';    
    },

    getMonthYearSwitchingState : function ()
    {
        return this.monthYearSwitchingState;
    }
});

Ext.reg('atdatepicker', DatePicker);

export default DatePicker



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_date_picker.js